import React, { PureComponent } from 'react'
import { ReactComponent as Icon } from './assets/Ice_Sign_Black.svg'
import SvgIcon from '@material-ui/core/SvgIcon'

export default class IceSign extends PureComponent {
  render() {
    return <SvgIcon component={Icon} viewBox='0 0 100 100' />
  }
}
